<script setup lang="ts">
import {formatting, LegacyOrder, legacyOrderKey, LegacyOrderRow} from '@hantera/portal-app';
import {computed, inject, Ref, ref} from 'vue';
import OrderRowAdjustment from '@/components/LegacyOrder/OrderRow/OrderRowAdjustment.vue'
import {EditableOrderRule} from '../editable-order-adjustment';
import OrderRowAddAdjustment from './OrderRowAddAdjustment.vue';
import {NewRowAdjustment, newRowAdjustmentKey, orderRulesKey} from '../order-keys';

const props = defineProps<{
  orderRow: LegacyOrderRow
}>()

const order = inject(legacyOrderKey, ref<LegacyOrder>(<any>{}));

const { currency, percent } = formatting;

const allRules = inject(orderRulesKey, <Ref<EditableOrderRule[]>><any>[]);
const newRowAdjustment = inject(newRowAdjustmentKey, <Ref<NewRowAdjustment>><any>{});

const qty = computed(() => {
  return props.orderRow.quantity.sub(props.orderRow.returnedQuantity).sub(props.orderRow.lostQuantity);
});

const rules = computed(() => {
  return allRules.value
    .filter(a =>
      a.affectedRows.findIndex(r => r.rowId === props.orderRow.rowId && r.isRowBased) >= 0
    );
});

</script>

<template>
  <div class="legacy-order-row-adjustments">
    <OrderRowAdjustment
      v-for="(rule, idx) in rules"
      :key="idx"
      :rule="rule"
      :order-row="orderRow"
    />
    <OrderRowAddAdjustment :order-row="orderRow" />
<!--    <template v-if="showSums">-->
<!--      <div class="legacy-order-row-adjustments__sum-percentage legacy-order-row-adjustments__sum">-->
<!--        {{ totalPercentage }}-->
<!--      </div>-->
<!--      <div class="legacy-order-row-adjustments__sum-unit legacy-order-row-adjustments__sum">-->
<!--        {{ totalUnitAdjustment }}-->
<!--      </div>-->
<!--      <div class="legacy-order-row-adjustments__sum-total legacy-order-row-adjustments__sum">-->
<!--        {{ currency(totalAdjustment, order.currencyCode) }}-->
<!--      </div>-->
<!--    </template>-->
  </div>
</template>

<style>
.legacy-order-row-adjustments {
  display: grid;
  grid-column: middle / -2;
  grid-template-columns: auto auto repeat(2, 50px);
  grid-auto-rows: min-content;
  row-gap: 3px;
  column-gap: 10px;
  text-align: right;
  padding: 5px;
  color: hsl(var(--color-text-50));
}

.legacy-order-row-adjustments__name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.legacy-order-row-adjustments__sum-percentage {
  grid-column: 1 / 3;
}

.legacy-order-row-adjustments__sum {
  font-weight: bold;
  color: hsl(var(--color-text));
}
</style>